import { appDispatch } from 'state'
import createPeriodicRefresher from 'utils/createPeriodicRefresher'
import { setFarmsPublicData, coreFarms } from 'state/farms'
import fetchFarms from 'state/farms/fetchFarms'
import { farmsConfig } from 'config/constants'

const coreFarmPids = coreFarms.map((f) => f.pid)
const activeFarms = farmsConfig.filter((farm) => !farm.isFinished && !coreFarmPids.includes(farm.pid))
const activeFarmPids = activeFarms.map((f) => f.pid)
const finishedFarms = farmsConfig.filter((farm) => farm.isFinished && !activeFarmPids.includes(farm.pid))

export const useCoreFarmsPeriodicFetching = createPeriodicRefresher(
  async () => {
    appDispatch(setFarmsPublicData(await fetchFarms(coreFarms)))
  },
  {
    frequency: 'normal',
    dbgName: 'CoreFarmsPublicDataPeriodicFetching',
  },
)

export const useActiveFarmsPeriodicFetching = createPeriodicRefresher(
  async () => {
    await useCoreFarmsPeriodicFetching.untilRefreshedOnce()
    appDispatch(setFarmsPublicData(await fetchFarms(activeFarms)))
  },
  {
    frequency: 'normal',
    dbgName: 'ActiveFarmsPublicDataPeriodicFetching',
  },
)

export const useFinishedFarmsPeriodicFetching = createPeriodicRefresher(
  async () => {
    await useActiveFarmsPeriodicFetching.untilRefreshedOnce()
    appDispatch(setFarmsPublicData(await fetchFarms(finishedFarms)))
  },
  {
    frequency: 'slow',
    dbgName: 'FinishedFarmsPublicDataPeriodicFetching',
  },
)
